import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/app/constants/constants';

@Injectable({
  providedIn: 'root'
})
export class DbMasterService {
  private httpLoaderHeader = { headers: new HttpHeaders().set(Constants.SKIP_LOADER_HEADER_KEY, 'true') };
  constructor(private baseService: BaseService) { }

  getMasterDetails(skipLoader: boolean = false): Observable<any> {
    return this.baseService.get<any>('DBMaster/GetDbMasterDetails', skipLoader ? this.httpLoaderHeader : {});
  }

  GetActiveQueryReferenceNumber(deactivateReqType: any, code: any): Observable<any> {
    return this.baseService.get<any>('DBMaster/GetActiveQueryReferenceNumber?deactivateReqType=' + deactivateReqType + '&code=' + code, { headers: { 'Skip-Loader': 'true' } });
  }

  getAllRoles(skipLoader:boolean = false): Observable<any> {
    return this.baseService.get<any>('DBMaster/GetAllRoles', skipLoader ? this.httpLoaderHeader : {});
  }
}
